import Vue from 'vue'

export default {
  getRequsities ({ commit }) {
    return Vue.axios.get(`/about/requisites`)
    .then(({ data }) => commit('ADD_REQUISITES', data))
  },
  addRequisite ({ commit }, data) {
    commit('ADD_NEW_REQUISITES', data)
  },
  updateRequisite ({ commit }, requisite) {
    commit('UPDATE_REQUISITE', requisite)
  },
  saveRequisites ({ commit }, requisites) {
    return Vue.axios.put(`/about/requisites`, { requisites })
  },
  deleteRequisite ({ commit }, id) {
    commit('DELETE_REQUISITES', id)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions/requisites.js